import { SelectedData } from './selected-data.component';

export * from './selected-data.component';
export default SelectedData;

if (!customElements.get('der-tm-appointment-booking-selected-data')) {
    customElements.define('der-tm-appointment-booking-selected-data', SelectedData);
}
